import { IonIcon } from '@ionic/react';
import { checkmarkOutline } from 'ionicons/icons';
import { useQuickBookmarks } from '../../context/QuickBookmarksContext/QuickBookmarksContext';
import { useTranslate } from '../../hooks/context/useTranslate';
import DateTimeTag from './DateTimeTag';

const QuickBookmarkReminder = () => {
  const { t } = useTranslate();
  const { dueBookmark, saving, update, show } = useQuickBookmarks();
  if (!dueBookmark) return null;
  return (
    <aside className="quick-bookmark-reminder" role="alert">
      <div className="quick-bookmark-reminder-title">
        {t('quickBookmarks.reminder')}
      </div>
      {dueBookmark.navigation && (
        <button
          type="button"
          className="quick-bookmark-reminder-path"
          onClick={() => show(dueBookmark)}
        >
          {dueBookmark.navigation.displayPath.join(' › ')}
        </button>
      )}
      <p>{dueBookmark.note}</p>
      <div className="quick-bookmark-reminder-time">
        {new Date(dueBookmark.reminderAt!).toLocaleString()}
      </div>
      <footer>
        <button
          type="button"
          disabled={saving}
          onClick={() => void update(dueBookmark.id, { status: 'completed' })}
        >
          <IonIcon icon={checkmarkOutline} />
          {t('quickBookmarks.completed')}
        </button>
        <DateTimeTag
          value={dueBookmark.reminderAt}
          label={t('quickBookmarks.postpone')}
          disabled={saving}
          onChange={(value) =>
            void update(dueBookmark.id, { reminderAt: value })
          }
        />
      </footer>
    </aside>
  );
};

export default QuickBookmarkReminder;
